import { createFileRoute } from '@tanstack/react-router'
import { ConfigSelection } from 'pages/productionDashboard/ConfigSelection'
import { productionDashboardSearchParams } from 'routes/production-dashboard/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return <ConfigSelection orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/production-dashboard/')({
  component: RouteComponent,
  validateSearch: productionDashboardSearchParams,
  staticData: {
    title: 'Production Dashboard',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: true,
    },
  },
})
